export const fetchText = async (path) => {
  if (!path) {
    return '';
  }
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Unable to fetch ${path}: ${response.status} ${response.statusText}`);
  }
  return response.text();
};

export const fetchArrayBuffer = async (path) => {
  if (!path) {
    throw new Error('Missing path for binary fetch');
  }
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Unable to fetch ${path}: ${response.status} ${response.statusText}`);
  }
  return response.arrayBuffer();
};
